module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/12f0G4R/tc-custom/9781937384234.jpg?1709148260232",
      "alt": "This image is the cover for the book Book of the Dead, Henry Gamadge"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Book of the Dead, Henry Gamadge\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A copy of Shakespeare’s "), _c('i', [_vm._v("The Tempest")]), _vm._v(" pulls a bookseller into a murder case in this mystery by Agatha Christie’s favorite American author.")]), _c('br'), _c('br'), _vm._v("The hospital sees nothing to question about the death of the reclusive Mr. Crenshaw, and it’s not as though he had any friends to press the issue. He did, though, have one casual acquaintance, who happens to pick up Mr. Crenshaw’s battered old edition of "), _c('i', [_vm._v("The Tempest")]), _vm._v("—and happens to pass that book on to Henry Gamadge. Gamadge, of course, is not only an expert in solving pesky problems but also an expert in rare books, and his two sets of expertise combine to uncover the extraordinary puzzle of Mr. Crenshaw, which began in California and ended on the other side of the country, at a chilly New England rendezvous."), _c('br'), _c('br'), _c('b', [_vm._v("“An absorbing yarn that holds up to the end.” —"), _c('i', [_vm._v("New York Times")])]), _c('br'), _c('br'), _c('b', [_vm._v("“Beautifully plotted, with believable characters and ample thrills” —"), _c('i', [_vm._v("Saturday Review of Books")])])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Elizabeth Daly\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Felony & Mayhem Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0